let global = {};
var environmentUrl = {
  //错误码：qhn;n90ytq1https://cvtest.263.net:7777/1.0/errors
  //开发环境
  development: {
    // owtUrl:"https://sipagent.link263.com:7777/",  //用户账号1： cv@test001.com   登录密码：net263    用户账号2： cv@test002.com    登录密码：net263
    // owtUrl:"https://zt.263dev.xyz:7777/",
    // owtUrl:'https://ld.263dev.xyz:7777/',
    //  owtUrl:' https://xayunshitest.263.net:7777',
    // owtUrl: "https://cvtest.263.net:7777/",
    // owtUrl: "https://lmshao.cn:7777",
    owtUrl: "https://cvtest.263.net",
    loginUrl: "https://gcc.263.net",
    cvaUrl: "https://cvadev.263.net/cga/", //cvtest@admin.com    登录密码：net263
    ScheduleServe: "https://cvmeetdev.263.net/login",
    rc: "http://cvdsdev.link263.com/cvds",
  },
  //测试环境
  testing: {
    owtUrl: "https://testcv.263.net/", //https://testcv.263.net/login
    loginUrl: "https://testcc.263.net",
    cvaUrl: "https://cvatest.263.net/cga/", //wq6@rh2020.net qqq111
    //yclhappy@admin.com/net263   /video@admin.com   net263
    //     管理员账号：cvtest@admin.com 登录密码：net263
    //用户账号1： cv@test001.com 登录密码：net263
    //用户账号2： cv@test002.com 登录密码：net263
    ScheduleServe: "https://cvmeettest.263.net/login",
    rc: "https://livetest.263cv.net/cvds/",
    shareFileUrl: "https://livetest.263cv.net",
    // ScheduleServe:'localhost:8081'
  },
  // 线上环境
  online: {
    owtUrl: "https://appserver.263cv.net", //https://cv.263.net/login
    loginUrl: "https://cclocation.263cv.net",
    cvaUrl: "https://cva.263.net/cga/",
    ScheduleServe: "https://cvmeet.263cv.net/login",
  },
  //生产环境:昌平环境j567
  production: {
    owtUrl: "https://appserver.263cv.net",
    loginUrl: "https://cclocation.263cv.net",
    cvaUrl: "https://cva.263.net/cga/",
    ScheduleServe: "https://cvmeet.263.net/login", // cva管理员：yangyang.shi@net263.com   密码：net263
  },
  // 其他环境高老师5环境
  other: {
    loginUrl: "https://gcc.263.net:18080",
    cvaUrl: "https://cvatest.263.net/cga/",
    //    owtUrl:"https://cvtest5.263.net:7777",
    owtUrl: "https://ld.zch828.xyz:7777",
  },
  ztUrl: {
    loginUrl: "https://gcc.263.net:18080",
    cvaUrl: "https://cvatest.263.net/cga/",
    owtUrl: "https://ld.zch828.xyz:7777",
  },
};
if (process.env.NODE_ENV == "production") {
  //开发环境
  if (process.env.type == "development") {
    global = environmentUrl.development;
  } else if (process.env.testType == "testing") {
    global = environmentUrl.testing;
  } else {
    // cv线上环境
    global = environmentUrl.online;
  }
} else {
  // 本地调试
  global = environmentUrl.testing;
}
export default global;
